// Mock data for Pond Skape website

export const images = {
  // Hero - Backyard waterfall with house in background
  hero: "https://customer-assets.emergentagent.com/job_living-water-1/artifacts/jf76ghrv_AC6B1537-5691-4F23-A0CC-A643ECB67ADF.png",
  
  // About page - Koi pond with clear water and fish
  about: "https://customer-assets.emergentagent.com/job_living-water-1/artifacts/ro6lcru5_IMG_0985.jpg",
  
  // Project images - Mix of backyard ponds, waterfalls, koi features
  projects: [
    "https://customer-assets.emergentagent.com/job_living-water-1/artifacts/9vb5iuy4_IMG_0985.jpeg", // Koi pond with visible fish
    "https://customer-assets.emergentagent.com/job_living-water-1/artifacts/lvtstvr4_AAA7E4E9-5258-444C-BB1F-430A00571B70.png", // Evening waterfall pond
    "https://customer-assets.emergentagent.com/job_living-water-1/artifacts/jf76ghrv_AC6B1537-5691-4F23-A0CC-A643ECB67ADF.png", // Backyard stream with house
    "https://images.pexels.com/photos/13643489/pexels-photo-13643489.jpeg", // Vibrant koi in clear pond
    "https://images.pexels.com/photos/21630798/pexels-photo-21630798.jpeg", // Koi in serene pond
    "https://images.unsplash.com/photo-1712049191286-1b46ad92586c" // Pond with aquatic plants
  ],
  
  // Texture/background
  texture: "https://customer-assets.emergentagent.com/job_living-water-1/artifacts/lvtstvr4_AAA7E4E9-5258-444C-BB1F-430A00571B70.png"
};

// Featured Projects - Real completed works by Pond Skape
export const featuredProjects = [
  {
    id: 1,
    name: "Guru Kund",
    location: "Gurugram, Haryana",
    type: "Multi-Cascade Waterfall & Fish Pond",
    description: "A stunning multi-level cascade waterfall flowing into a naturalistic fish pond, featuring carefully arranged river rocks, decorative planters, and lush surrounding greenery. This residential project transforms a backyard into a serene water sanctuary.",
    features: ["Multi-cascade waterfall", "Fish pond", "Natural stone arrangement", "Decorative water bowls", "Integrated landscaping"],
    images: [
      "https://customer-assets.emergentagent.com/job_8d30ae3e-05c7-4a7a-a439-e00450d9e8af/artifacts/ok88kmgf_Gurukund%205_AI.png",
      "https://customer-assets.emergentagent.com/job_8d30ae3e-05c7-4a7a-a439-e00450d9e8af/artifacts/pa6yxv7m_Gurukund%207_AI.png",
      "https://customer-assets.emergentagent.com/job_8d30ae3e-05c7-4a7a-a439-e00450d9e8af/artifacts/99j0zt1m_Gurukund%204_AI.png"
    ],
    featured: true
  },
  {
    id: 2,
    name: "Doon Dharika",
    location: "Dehradun, Uttarakhand",
    type: "Koi Pond with Stream & Water Fountain",
    description: "A tranquil koi pond ecosystem nestled in the foothills of the Himalayas. This project features vibrant koi fish swimming in crystal-clear water, a gentle stream flowing through natural rock formations, and a central water fountain that provides aeration for the fish while creating a soothing ambiance.",
    features: ["Koi fish pond", "Water fountain for fish", "Natural stream", "River rock borders", "Tropical plants", "Decorative water bowls"],
    images: [
      "https://customer-assets.emergentagent.com/job_8d30ae3e-05c7-4a7a-a439-e00450d9e8af/artifacts/jtkryib7_Doon%20Dharika%202.jpg",
      "https://customer-assets.emergentagent.com/job_8d30ae3e-05c7-4a7a-a439-e00450d9e8af/artifacts/triwdz0v_Doon%20DHarika%203.png",
      "https://customer-assets.emergentagent.com/job_8d30ae3e-05c7-4a7a-a439-e00450d9e8af/artifacts/t5w3zdr8_Doon%20DHarika%206.png",
      "https://customer-assets.emergentagent.com/job_8d30ae3e-05c7-4a7a-a439-e00450d9e8af/artifacts/00jq1vfl_DOON%20DHARIKA_5.jpg",
      "https://customer-assets.emergentagent.com/job_8d30ae3e-05c7-4a7a-a439-e00450d9e8af/artifacts/qlr8wnqd_DOON%20DHARIKA_PROCESSED_3.jpg"
    ],
    featured: true
  },
  {
    id: 3,
    name: "Himadhara",
    location: "Himachal Pradesh",
    type: "Natural River Stream with Waterfall & Pool",
    description: "A breathtaking natural river stream installation set against the majestic Himalayan mountains. Water flows from a decorative bowl through a series of natural river rocks, creating gentle cascades before collecting in a serene pool. This project captures the essence of a mountain stream, bringing the tranquil sounds and beauty of flowing water to a hillside retreat.",
    features: ["Natural river stream", "Small waterfall cascade", "Collecting pool", "Mountain river rocks", "Decorative water bowl", "Hillside integration", "Panoramic mountain views"],
    images: [
      "https://customer-assets.emergentagent.com/job_8d30ae3e-05c7-4a7a-a439-e00450d9e8af/artifacts/xf1beb5u_Himadhara%203.png",
      "https://customer-assets.emergentagent.com/job_8d30ae3e-05c7-4a7a-a439-e00450d9e8af/artifacts/zvaqjx7x_Himadhara%204.png",
      "https://customer-assets.emergentagent.com/job_8d30ae3e-05c7-4a7a-a439-e00450d9e8af/artifacts/ueoie4mv_Himadhara%206.png",
      "https://customer-assets.emergentagent.com/job_8d30ae3e-05c7-4a7a-a439-e00450d9e8af/artifacts/4ff62s82_Himadhara%207.png"
    ],
    featured: true
  }
];

export const waterFeatureTypes = [
  {
    id: 1,
    title: "Natural Water Bodies",
    description: "Reflective surfaces and water environments that respond to landscape and spatial experience.",
    image: images.projects[0]
  },
  {
    id: 2,
    title: "Flowing Water Forms",
    description: "Movement-based water features that create atmosphere through sound and visual flow.",
    image: images.projects[1]
  },
  {
    id: 3,
    title: "Habitat-Supporting Environments",
    description: "Water spaces that may integrate ecological processes when appropriate for the site.",
    image: images.projects[2]
  },
  {
    id: 4,
    title: "Atmospheric Elements",
    description: "Water as spatial experience—shaping feeling, cooling, and seasonal character.",
    image: images.projects[3]
  },
  {
    id: 5,
    title: "Integrated Landscapes",
    description: "Site-responsive water environments designed for residential, hospitality, and collaborative projects.",
    image: images.projects[4]
  }
];

export const ecosystemComponents = [
  {
    title: "Continuous Water Movement",
    description: "Pumps and filtration systems that keep water flowing, preventing stagnation and maintaining oxygen levels.",
    icon: "Waves"
  },
  {
    title: "Aquatic Plants",
    description: "Carefully selected water plants that filter nutrients, provide oxygen, and create natural beauty.",
    icon: "Sprout"
  },
  {
    title: "Beneficial Bacteria",
    description: "Natural biological filtration that breaks down waste and keeps water clear and healthy.",
    icon: "Sparkles"
  },
  {
    title: "Rocks & Pebbles",
    description: "Natural stone that provides habitat for beneficial bacteria and creates authentic water feature aesthetics.",
    icon: "Mountain"
  },
  {
    title: "Fish & Wildlife",
    description: "Koi, goldfish, and other aquatic life that complete the ecosystem while bringing color and movement.",
    icon: "Fish"
  }
];

export const designPhases = [
  {
    number: "01",
    title: "Site Understanding",
    description: "We begin by reading the land—slope, drainage, sunlight, climate, and surrounding landscape. Form follows environment."
  },
  {
    number: "02",
    title: "Spatial Concept",
    description: "Water behavior and spatial experience. How the environment will be felt, viewed, and integrated with place."
  },
  {
    number: "03",
    title: "Structural Strategy",
    description: "Material approach and containment systems that ensure long-term reliability and natural integration."
  },
  {
    number: "04",
    title: "Flow & Circulation",
    description: "Water movement designed for real operating conditions—not idealized scenarios."
  },
  {
    number: "05",
    title: "Ecological Integration",
    description: "Where appropriate, natural processes may support balance. Level varies with climate, scale, and operation."
  },
  {
    number: "06",
    title: "Long-term Operation",
    description: "Design for how systems are actually used—adapting to maintenance patterns and changing conditions."
  }
];

export const whyDifferent = [
  {
    title: "Site-Responsive",
    description: "Every project is shaped by terrain, climate, and context. Form follows environment—not templates."
  },
  {
    title: "Human Scale",
    description: "We focus on practical, livable water environments that integrate with real landscapes and operations."
  },
  {
    title: "Experience-Driven",
    description: "Water changes how a space feels through movement, reflection, sound, and seasonal presence."
  },
  {
    title: "Ecology Where Appropriate",
    description: "Natural processes may support balance—but design adapts to actual conditions and use patterns."
  }
];

export const environmentalBenefits = [
  {
    title: "Biodiversity Support",
    description: "Natural water landscapes can provide habitat for birds, insects, amphibians, and aquatic life.",
    icon: "Leaf"
  },
  {
    title: "Groundwater Protection",
    description: "Thoughtful water design helps recharge aquifers and protects soil from erosion.",
    icon: "Droplets"
  },
  {
    title: "Microclimate Cooling",
    description: "Water surfaces naturally cool surrounding air, improving thermal comfort.",
    icon: "Wind"
  },
  {
    title: "Air Quality",
    description: "Vegetation around water features filters air and produces oxygen.",
    icon: "Trees"
  }
];

export const videoPlaceholder = {
  url: "https://player.vimeo.com/video/example",
  thumbnail: images.projects[0],
  title: "Pond Skape Design Process"
};
